import React from 'react';
import {StyleSheet, SafeAreaView, View} from 'react-native';
import ModuleSlidesView from './ModuleSlidesView';
import {drawerListBackgroundColor} from '../../utils/utils';
import {useNavigation, useRoute} from '@react-navigation/native';
import {CustomStatusBar} from '../../utils/customStatusBar';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import logger from '../../utils/logger';
export const ModulesSlidesContainer = props => {
   const navigation = useNavigation();
   const mSlide = useRoute().params;
   const isLandscapemode = useSelector(selectScreenOrientation);
   return (
      <SafeAreaView
         style={[
            styles.container,
            {
               backgroundColor: !isLandscapemode
                  ? drawerListBackgroundColor
                  : 'black',
            },
         ]}>
         <CustomStatusBar backgroundColor={drawerListBackgroundColor} />
         <ModuleSlidesView
            cModuleSlide={mSlide}
            onRowSelected={id => {
               //Navigate to Module details
               //props.navigation.navigate('ModuleDetails');
               logger('move to modules list');
            }}
            navigation={navigation}
         />
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
   },
});
